export enum SNOMEDCodes {
  LaboratoryProcedure = "108252007",
  ImagingProcedure = "363679005",
  DiagnosticProcedure = "103693007",
  Unknown = "3219008",
  PregnancyRecord = "77386006",
}
